import type { PluginDefinition } from "../../types";

export interface FreeTextConfig {
  prompt: string;
  min_words: number;
}

export interface FreeTextPayload {
  text: string;
}

export const DEFAULT_MIN_WORDS = 50;

export const countWords = (text: string): number =>
  text.trim().split(/\s+/).filter(Boolean).length;

export const FREE_TEXT_DEFINITION: PluginDefinition<FreeTextConfig> = {
  subType: "free_text",
  label: "Free Text Response",
  gradeable: true,
  gradingType: "manual",
  defaultConfig: () => ({ prompt: "", min_words: DEFAULT_MIN_WORDS }),
  offeredComponents: () =>
    Promise.resolve([
      {
        label: "Free Text Response",
        description: "A written response graded by the instructor",
        icon: "fa-pencil-square-o",
      },
    ]),
  loadComponents: () => Promise.all([import("./config/jnctFreeTextConfig"), import("./student/jnctFreeTextStudent"), import("./grading/jnctFreeTextGrading")]),
};
